<script lang="ts">
  import { getContext } from 'svelte';

  import { Button, Tag, TagTypes } from '$shared/components';
  import Label from '$shared/constants/Label';
  import type { VerificationOverviewTableRow } from '$shared/models/VerificationOverviewTableRow';
  import { DatasetJobStatus } from '$shared/constants/DatasetJobStatus';
  import { GlobalAppContextKey } from '$shared/constants/GlobalAppContextKey';
  import type { Readable } from 'svelte/store';
import { ButtonStyle } from '$shared/constants/ButtonStyle';
import { TagSize } from '$shared/constants/TagSize';

  interface Props {
    row: VerificationOverviewTableRow;
    column: ColumnType;
    onevent?: (row: VerificationOverviewTableRow) => void;
  }

  let { row, column, onevent }: Props = $props();

  const context = getContext<Readable<{ readonly: boolean }>>(
    GlobalAppContextKey.OverviewSectionContextStore
  );

  let tagType = $derived(row?.status === DatasetJobStatus.Failed ? TagTypes.Greyed : TagTypes.None);

  const onClickVerify = () => {
    onevent?.(row);
  };
</script>

{#if !row?.hasVerificationNotSupported && !row?.isLoading && row?.isVerifyLater}
  <Button
    name="dea-verify"
    style={ButtonStyle.Link}
    disabled={$context?.readonly}
    onclick={onClickVerify}
  >
    {Label.Verify}
  </Button>
{:else if row?.status}
  <Tag size={TagSize.Small} type={tagType}>{row.status}</Tag>
{/if}

<style>
  /* Styles apply here */
</style>
